export const TableShimmer = () => {
  return (
    <div className="flex h-full w-full animate-pulse flex-col rounded-md p-3" data-testid="shimmer-loader-table">
      <div className="mb-2 flex h-10 w-full space-x-4 overflow-hidden">
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
      </div>
      <div className="flex h-full w-full space-x-4 overflow-hidden">
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
        <div className="h-full w-2/12 rounded bg-gray-300" />
      </div>
    </div>
  )
}

export const WaffleShimmer = () => {
  return (
    <div className="flex h-full w-full animate-pulse flex-col p-1" data-testid="shimmer-loader-waffle">
      <div className="h-full w-full rounded-md bg-gray-300 " />
    </div>
  )
}
